import { buildPaginatedListStore } from "./utils/storeBuilders";

export const useCustomerCallListStore = buildPaginatedListStore("customerCallList", "/customer-calls/", "Aucun appel client trouvé", true);
